import React from "react";
import "./Beach.css";
import beach from "../../img/about/beach.png";

function Beach() {
  return (
    <div className="Beach">
      <div className="Beach__mobile__img">
      <img src={beach} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
       <div className="Beach__img">
        <img src={beach} alt="Luxury villa with sea view in Costa Blanca, Spain" />
      </div>
      <div className="Beach__txt">
        <h1>Beaches</h1>
        <p>
          The Costa Blanca, known for its stunning coastline along the
          Mediterranean Sea, offers a diverse range of beaches to suit every
          preference, whether you're looking for family-friendly facilities,
          water sports opportunities, or secluded relaxation in a natural
          setting.
          <br />
          <br />
          Sandy beaches for sunbathing and building sandcastles like Playa de la
          Granadella in Jávea ; Playa del Albir near Altea and Playa de la Grava
          in Jávea are examples of pebble beaches. Some beaches along the Costa
          Blanca are more secluded and less developed, offering a peaceful and
          natural environment.
          <br />
          <br />
          These beaches are ideal for those seeking tranquility and privacy:
          Cala Ambolo in Jávea and Cala del Moraig in Benitachell are examples
          of natural and remote beaches.
        </p>
      </div>
     
    </div>
  );
}

export default Beach;
